import { IPalette } from '@fluentui/react/lib/Styling';

const borderStyleString = (palette: IPalette): string => {
  return '1px solid ' + palette.neutralLight;
};

export const borderStyle = (palette: IPalette): React.CSSProperties => {
  return {
    border: borderStyleString(palette)
  };
};

export const borderLeftStyle = (palette: IPalette): React.CSSProperties => {
  return {
    borderLeft: borderStyleString(palette)
  };
};

export const borderRightStyle = (palette: IPalette): React.CSSProperties => {
  return {
    borderRight: borderStyleString(palette)
  };
};

export const borderTopStyle = (palette: IPalette): React.CSSProperties => {
  return {
    borderTop: borderStyleString(palette)
  };
};

export const borderBottomStyle = (palette: IPalette): React.CSSProperties => {
  return {
    borderBottom: borderStyleString(palette)
  };
};
